<header class="header-container-wrapper" id="header">
    <div class="main-header d-lg-block d-none">
        <div class="container-wrapper">
            <div class="container">
                <div class="row align-items-center">
                    <div class="col-md-12 header-link">
                        <ul>
                            <li>
                                <a href="https://www.bajajcapital.com/help-centre#branch" (click)="registerGANav1('Branch Locator')">
                                    <!-- <img
                                        src="assets/images/placeholder.svg" alt="" width="11">
                                     -->

                                    <span class="material-icons-outlined">
                                        location_on
                                    </span> Branch Locator</a>

                            </li>
                            <li>
                                <a href="https://www.bajajcapital.com/help-centre#query" (click)="registerGANav1('Request Callback')">
                                    <!-- <img
                                        src="assets/images/phone-02.svg" alt="" width="11" height="11">  -->
                                    <span class="material-icons-outlined">
                                        phone
                                    </span>
                                    Request
                                    Callback</a>
                            </li>
                            <li class="d-flex noAfter">
                                <!-- <a href="tel:{{tollFreeNoLink}}"  (click)="registerGANav(tollFreeNoLink)" ><img src="assets/images/phone-02.svg" alt="" width="11"> <span class="greenC"> {{tollFreeNoLink}} </span> </a>                                </li> -->

                                <a class="" href="tel:{{tollfree_number}}" (click)="registerGANav1(tollfree_number)">
                                    <!-- <img
                                        src="assets/images/phone-02.svg" alt="" width="11" height="11"> -->

                                    <span class="material-icons-outlined">
                                        phone
                                    </span>
                                    <span class="greenC"> {{tollfree_number}} </span> </a>
                                <!-- <span class="seprate" *ngIf="display_tollfree_sec">/</span> -->
                                <!-- <a *ngIf="display_tollfree_sec" href="tel:{{tollfree_2}}" class="noAfterchild"
                                    (click)="registerGANav1(tollfree_2)"> <span class="greenC"> {{tollfree_2}} </span>
                                </a> -->
                            </li>
                            <li>

                            </li>
                            <li>
                                <a href="javascript:void(0);" class="hamburger-menu"> <span class="menuB d-flex align-items-center"> Menu
                                        <span class="material-icons-outlined">
                                            menu
                                        </span>
                                        <!-- <img
                                            class="oppNone" src="../../../assets/images/menu.svg" alt="" width="16"
                                            height="16"> -->


                                    </span></a>
                            </li>
                        </ul>
                    </div>
                    <div class="col-md-3 logo">
                        <a href="https://www.bajajcapital.com/" (click)="registerGALogo()">
                            <picture>
                                <source srcset="assets/images/logo-bajaj-capital.webp" type="image/webp">
                                <img src="assets/images/logo-bajaj-capital.png" alt="BCL" width="210" height="41"
                                id="logochange">
                            </picture>
                        </a>
                    </div>
                    <div class="col-md-9 d-flex justify-content-end">
                        <div class="main-nav mega-menu">
                            <ul>
                                <li class="has-children" *ngFor="let menu of menuLinks">
                                    <a href="{{menu.url}}" target="{{menu.target}}"
                                        (click)="registerGANav(menu.name)">{{menu.name}}</a>
                                </li>
                                <li>
                                    <a class="wealth_cta"
                                        href="https://wealth.bajajcapital.com/login?utm_source=https://www.bajajcapital.com/&utm_medium=website&utm_id=from_bcl"
                                        target="_blank">LOGIN</a>
                                </li>
                            </ul>
                        </div>
                        <div class="d-flex align-items-center">
                            <a href="javascript:void(0)" class="hamburger-menu show-on-scroll">
                                <!-- <img
                                    src="assets/images/menu.svg" alt="" width="16"> -->

                                <span class="material-icons-outlined">
                                    menu
                                </span>
                            </a>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div class="mobile-header d-lg-none">
        <div class="container">
            <div class="row">
                <div class="col-7">
                    <div class="mobile-logo">
                        <a [routerLink]="" class="hamburger-menu">
                            <!-- <img src="assets/images/menu.svg" alt="" width="18"> -->
                            <span class="material-icons-outlined">
                                menu
                            </span>
                        </a>
                        <a [routerLink]="['/']" class="logo">
                            <picture>
                                <source srcset="assets/images/logo-bajaj-capital.webp" type="image/webp">
                                <img src="assets/images/logo-bajaj-capital.png"
                                id="moblogochange" alt="Bajaj Capital" width="120" height="120">
                            </picture>
                        </a>
                    </div>
                </div>
                <div class="col-5">
                    <div class="mobile-header-links">
                        <ul>
                            <li class="d-none">
                                <a href="tel:{{tollfree_number}}">
                                    <!-- <img src="assets/images/phone.svg" alt="" width="14" height="14"> -->
                                    <span class="material-icons-outlined">
                                        phone
                                    </span>
                                </a>
                            </li>

                            <li class="d-none">
                                <app-search-mobile></app-search-mobile>
                            </li>
                            <li class="wealth_cta">
                                <a href="https://wealth.bajajcapital.com/login" target="_blank">LOGIN</a>
                            </li>
                        </ul>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <app-hamburger-menu [hamburgerMenuarr]="hamburgerMenu" [branch_locator]="branch_locator"
        [request_callback]="request_callback" [tollfree_number]="tollfree_number"
        [tollfree_num_2]="tollfree_2"></app-hamburger-menu>
</header>